import createNamespaceContext from './helper/createNamespaceContext';
export const ELEMENTS_CONTEXT = 'fabricElementsCtx';
export const FabricElementsAnalyticsContext = createNamespaceContext(ELEMENTS_CONTEXT, 'FabricElementsAnalyticsContext');